const isWeb = true;
import { getSystemType } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
let libs;
if (true)
    libs = require('@nibfe/mkt-libs');
export function getUTM() {
    try {
        const systemType = getSystemType();
        let utm_medium = systemType === SystemType.android ? 'android' : 'iphone';
        if (isWeb && libs) {
            const { env } = libs;
            if (env.miniProgram.isMiniProgram()) {
                utm_medium = 'WEIXINPROGRAM';
            }
            else {
                // eslint-disable-next-line no-nested-ternary
                utm_medium = env.system.isAndroid() ? 'android' : env.system.isIphone() ? 'iphone' : '';
            }
        }
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
